// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + ({"5290":"6f9538d6","8177":"7ee3d5a0","8990":"b2d08614"}[chunkId] || chunkId) + "." + {"5048":"52134f887d222ecb","5221":"2782babd0e0ebceb","5290":"02c19b09fd775d93","6637":"ffbbb758076fbf17","6657":"fd1548f0e6900441","8177":"2219c93b654ef720","8990":"7a04300bc5ffb2e1"}[chunkId] + ".js";
};